var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-divider', {
    staticClass: "custom-divider-margin-top"
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.optionsSetting')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.labelKeyName')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionModel.labelKey),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "labelKey", $$v)
      },
      expression: "optionModel.labelKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.valueKeyName')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionModel.valueKey),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "valueKey", $$v)
      },
      expression: "optionModel.valueKey"
    }
  })], 1), _vm._v(" "), (_vm.hasConfig('childrenKey')) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.childrenKeyName')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.optionModel.childrenKey),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "childrenKey", $$v)
      },
      expression: "optionModel.childrenKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dsEnabled')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.dsEnabled),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dsEnabled", $$v)
      },
      expression: "optionModel.dsEnabled"
    }
  })], 1), _vm._v(" "), (!!_vm.optionModel.dsEnabled) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dsName')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getDataSetList
    },
    model: {
      value: (_vm.optionModel.dsName),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dsName", $$v)
      },
      expression: "optionModel.dsName"
    }
  }, _vm._l((_vm.dataSourceList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "title": item.description,
        "label": item.uniqueName,
        "value": item.uniqueName
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!!_vm.optionModel.dsEnabled) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dataSetName')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.optionModel.dataSetName),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dataSetName", $$v)
      },
      expression: "optionModel.dataSetName"
    }
  }, _vm._l((_vm.dataSetList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "title": item.remark,
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.optionModel.dsEnabled) ? _c('el-form-item', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('option-items-setting', {
    attrs: {
      "designer": _vm.designer,
      "selected-widget": _vm.selectedWidget
    }
  })], 1) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ccb74c6e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/optionItems-editor.vue
// module id = null
// module chunks = 